const MandataireMapPanelMesuresStyle = {
  height: "100%",
  pr: "2",
  width: "600px",
};

export { MandataireMapPanelMesuresStyle };
